import { render, staticRenderFns } from "./offer-groups.vue?vue&type=template&id=54aa1e5e"
import script from "./offer-groups.vue?vue&type=script&lang=js"
export * from "./offer-groups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports